export default __webpack_public_path__ + "static/media/icon_suport.c9bb7dd7.svg";